import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface FormCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  fullWidth?: boolean;
}

export const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  ({ label, hint, className, fullWidth, ...props }, ref) => {
    const inputId = props.id ?? `chk-${label.replace(/\s+/g, '-').toLowerCase()}`;
    return (
      <label
        htmlFor={inputId}
        className={cn(
          'flex items-start gap-2 rounded-md border border-border bg-background p-2.5 text-sm hover:bg-muted/30',
          fullWidth && 'sm:col-span-2',
          className,
        )}
      >
        <input
          id={inputId}
          ref={ref}
          type="checkbox"
          className="mt-0.5 h-4 w-4 rounded border-border accent-primary"
          {...props}
        />
        <span className="leading-tight">
          <span className="block">{label}</span>
          {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
        </span>
      </label>
    );
  },
);
FormCheckbox.displayName = 'FormCheckbox';
